module.exports = __webpack_public_path__ + "img/avatar0.2df2a274.png";